import { mockUtils } from "../../../development/mocks/mock-utils";
import { globalApiMock } from "../../events-screen/parent-events-mocks/global.api.mock";
import {
  getRandomMemberFromString,
  numberFromString,
} from "../../events-screen/parent-events-mocks/mock-utils-functions";
import { parentEventsMocks } from "../../events-screen/parent-events-mocks/parent-events.mock";
import { BaseDiscountModel } from "../discount-models/BaseDiscountModel";

const firstNames = mockUtils.hebFirstNames;

const hebLastNames = mockUtils.hebLastNames;

const citiesAndNests = mockUtils.citiesAndNests;

const streets = [
  "הרצל",
  "התמר",
  "הצבי",
  "טרומפלדור",
  "חיים",
  "מסדה",
  "הגפן",
  "אלון",
];

const nest = globalApiMock.nests.map((n) => n.name);
const layers = globalApiMock.layers.map((l) => l.layerName);
const parentEventMocks = parentEventsMocks.mainMock;

const addLongStringsToBaseDiscountModel = (
  model: BaseDiscountModel
): BaseDiscountModel => {
  const clonedModel = { ...model };
  const longNameString = "  כהן אהברמסקי  ינאי ";
  const longEventString = "לחניכים   עם שם מאד ארוך ";

  clonedModel.childLastName = clonedModel.childLastName + longNameString + " ";
  clonedModel.childEventName =
    clonedModel.childEventName + longEventString + " ";
  clonedModel.parentEventName =
    clonedModel.parentEventName + longEventString + " ";
  clonedModel.childNest = "קן באיזור חיפה עם שם מאד ארוך";

  return clonedModel;
};

export const baseDiscountMocks: BaseDiscountModel[] = [
  ...hebLastNames,
  ...hebLastNames,
].map((lastName, intIndex) => {
  const numberOfMembers = Math.floor(Math.random() * 3) + 1;
  const familyHash = `${lastName}${intIndex}${numberOfMembers}`;
  const familyHashInt = numberFromString(familyHash, 100000);
  const intFromHash = numberFromString(familyHash, citiesAndNests.length);
  // tslint:disable-next-line:no-bitwise
  const address = ` ${streets[numberFromString(familyHash, streets.length)]} ${
    Math.floor(Math.random() * 90) + 1
  }, ${citiesAndNests[intFromHash]}`;
  const randomParentEvent = getRandomMemberFromString(
    familyHash,
    parentEventMocks
  );
  const discounts: BaseDiscountModel = {
    discountId: numberFromString(familyHash, 100000) + intIndex,
    childFirstName: getRandomMemberFromString(familyHash, firstNames),
    childLastName: lastName,
    childIsraeliId: Math.floor(Math.random() * 1000000000).toString(),
    childNest: citiesAndNests[intFromHash],
    childLayer: layers[Math.floor(Math.random() * (layers.length - 4))],
    childId: numberFromString(familyHash, 10000) + intIndex,
    childCounty: "מחוז שרון",
    parentEventName: randomParentEvent.eventName,
    parentEventCode: randomParentEvent.parentEventCode,
    childEventName: "דמי חבר",
    childEventCode: randomParentEvent.parentEventCode + "1",
    originalPrice: 100,
    priceAfterDiscount: 80,
    discountAmount: 20,
    numberOfPayments: 1,
    discountDate: new Date(),
    approvedBy: "יוסף אברהמי",
    passedCommittee: true,
    comments: "הועדה אישרה את הסבסוד ברוב קולות",
    canEdit: true,
    childPayed: false,
  };
  if (intIndex % 5 === 2) {
    discounts.childPayed = true;
    discounts.canEdit = false;
  } else if (intIndex % 5 === 1) {
    discounts.childPayed = false;
    discounts.canEdit = false;
  }
  if (intIndex === 1) {
    return addLongStringsToBaseDiscountModel(discounts);
  }
  return discounts;
});



// WEBPACK FOOTER //
// ./src/app/admin/discounts/mock/baseDiscount.mock.ts